import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import media from '@styles/media'
import * as LogoLibrary from '@logos'

function StackLinks({ links, dark, fill = '#73737D' }) {
  if (!links) return null

  return (
    <>
      {links.map((link) => {
        if (!link) {
          return
        }
        // set up link icon
        const Icon = LogoLibrary[link.logo]

        return (
          <StackLink
            // as={internal ? Link : null}
            // to={`/${parent.pathPrefix}/${parent.slug}`}
            to={link.url ? link.url : null}
            key={link.url ? link.url : null}
            href={link.url ? link.url : null}
            target={link.url ? '_blank' : null}
            rel={link.url ? 'noopener' : null}
            style={link.url ? { cursor: 'pointer' } : { cursor: 'default' }}
            title={link.name}
            data-a11y="false"
            aria-label={link.url ? `Link to ${link.url}` : link.name}
            dark={dark ? 1 : 0}
            inactive={link.url ? 0 : 1}
          >
            {Icon ? <Icon aria-hidden="true" fill="unset" /> : null}
            <Hidden>Link to {link.name}</Hidden>
          </StackLink>
        )
      })}
    </>
  )
}

export default StackLinks

// TODO: Get colors from theme : ${(p) => p.theme.colors.${colorName}}
const StackLink = styled.a`
  position: relative;
  font-weight: 800;
  color: ${(p) => (p.dark ? '#08080B' : '#fff')};

  &:nth-child(n + 2) {
    margin-left: 13px;
  }

  &[data-a11y='true']:focus::after {
    content: '';
    position: absolute;
    left: -10%;
    top: -42%;
    width: 120%;
    height: 200%;
    border: 2px solid ${(p) => p.theme.colors.blue};
    background: rgba(255, 255, 255, 0.01);
    border-radius: 5px;
  }
  &:hover {
    svg {
      fill: ${(p) => (p.dark ? 'rgba(8, 8, 11, 1)' : 'rgba(255, 255, 255, 1)')};
    }
  }

  svg {
    height: 1.4em;
    width: auto;
    fill: ${(p) =>
      p.dark ? 'rgba(8, 8, 11, 0.5)' : 'rgba(255, 255, 255, 0.5)'};
  }

  ${media.tablet`
       display: block;
       margin: 0 0;
       color: ${(p) => (p.dark ? '#08080B' : '#fff')};
     `}
`

const Hidden = styled.span`
  width: 0px;
  height: 0px;
  visibility: hidden;
  opacity: 0;
  overflow: hidden;
  display: inline-block;
`
